/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchUrl = {
    currentCategoryPath: window.liveSearchConfig.currentCategoryPath,
    lastVisitedCategoryPath: "",
    urlParams: new URLSearchParams(window.location.search),
    prevUrl: null,
    nextUrl: null,
    /**
     * Add or update URL parameters
     *
     * @param {string} key
     * @param {string} value
     */
    addOrUpdateUrlParam(key, value) {
        try {
            this.urlParams.set(key, value);
            this.updateUrl();
        } catch (error) {
            console.error(`Failed to add or update URL parameter: ${error}`);
        }
    },
    /**
     * Remove URL parameter
     *
     * @param {string} key
     */
    removeUrlParam(key) {
        try {
            this.urlParams.delete(key);
            this.updateUrl();
        } catch (error) {
            console.error(`Failed to remove URL parameter: ${error}`);
        }
    },
    /**
     * Update the URL with current parameters
     */
    updateUrl() {
        try {
            const paramsString = this.urlParams.toString();
            const updatedUrl = paramsString
                ? `${window.location.pathname}?${paramsString}`.replace(/%2B/g, '+')
                : window.location.pathname;

            window.history.replaceState({}, '', updatedUrl);
        } catch (error) {
            console.error(`Failed to update URL: ${error}`);
        }
    },
    /**
     * Handle head link tags
     */
    handlePrevNextLinkTags() {
        const head = document.head;
        const canonicalUrl = document.querySelector('link[rel="canonical"]')?.href;

        if (canonicalUrl) {
            head.querySelectorAll('link[rel="prev"], link[rel="next"]')
                .forEach(linkTag => head.removeChild(linkTag));

            this.prevUrl = this.pagesCurrent > 1
                ? this.getPrevUrl(canonicalUrl)
                : null;
            this.nextUrl = this.pagesCurrent < this.pagesTotal
                ? this.getNextUrl(canonicalUrl)
                : null;

            if (this.prevUrl) {
                head.appendChild(Object.assign(document.createElement('link'), {
                    rel: 'prev',
                    href: this.prevUrl
                }));
            }

            if (this.nextUrl) {
                head.appendChild(Object.assign(document.createElement('link'), {
                    rel: 'next',
                    href: this.nextUrl
                }));
            }
        }
    },
    /**
     * Get the previous URL
     * @param {string} canonicalUrl
     * @returns {string}
     */
    getPrevUrl(canonicalUrl) {
        const url = new URL(canonicalUrl);
        const currentPage = this.pagesCurrent;
        if (url.searchParams.has("p")) {
            url.searchParams.set("p", String(currentPage - 1));
            return url.href;
        }
    },
    /**
     * Get the next URL
     * @param {string} canonicalUrl
     * @returns {string}
     */
    getNextUrl(canonicalUrl) {
        const url = new URL(canonicalUrl);
        const currentPage = this.pagesCurrent;
        if (url.searchParams.has("p")) {
            url.searchParams.set("p", String(currentPage + 1));
            return url.href;
        }
    },
    /**
     * Get current page from URL
     *
     * @returns {number|null}
     */
    getCurrentPageFromUrl() {
        return parseInt(new URLSearchParams(window.location.search).get("p")) || 1;
    },
    /**
     * Load facets from URL parameters
     * Exclude non facets parameters
     */
    loadFacetsFromUrl() {
        if (this.urlParams.size > 0) {
            this.urlParams.forEach((value, key) => {
                if (this.excludedUrlParams.indexOf(key) === -1) {
                    this.selectedFacets.push({
                        attribute: decodeURIComponent(key),
                        option: decodeURIComponent(value)
                    });
                }
            });
        }
    },
    /**
     * Update the URL with the current page number.
     * This is used to update the URL when the user scrolls to a new page.
     * @param {number} page
     */
    setUrlPageParam(page) {
        this.pagesCurrent = page;

        const newUrl = new URL(window.location);
        newUrl.searchParams.set("p", String(page));

        // Only update history state if not already the same
        if (window.location.search !== newUrl.search) {
            window.history.replaceState({}, "", newUrl);
        }
    },
    resetUrlPageParam() {
        const newUrl = new URL(window.location);
        newUrl.searchParams.delete("p");
        window.history.replaceState({}, "", newUrl);
    }
}

export default liveSearchUrl;
